<template>
  <div class="notfound">
    <div>您访问的页面不存在~</div>
    <p>点击返回 <router-link to="/home">企业福利助手首页</router-link></p>
  </div>
</template>
<script>
export default {
  name: 'NotFound'
}
</script>
<style lang="less" scoped>
.notfound {
  text-align: center;
  div {
    font-size: 40px;
    margin: 200px 0px 30px;
  }
  p {
    font-size: 20px;
    a {
      text-decoration: underline;
    }
  }
}
</style>
